import PropTypes from 'prop-types';
function TeacherStatsReferredTeachers({ isTeacher, numTeachersReferred }) {
    function showLink() {
        if (!isTeacher) return null;
        return <div><p>Help a teacher get started with DonorsChoose and <a href='/refer'>earn $25 for your next referral</a>.</p></div>;
    }

    return (
        <section className='teachersReferred'>
            <section className='teachersReferredWrapper'>
                <div aria-label='referral graphic' className='illustration referral'></div>
                <div className='teachersReferredCount'><h2>{numTeachersReferred}</h2></div>
                <div className='teachersReferredHeader'>
                    <h3>Referred teacher{ numTeachersReferred === 1 ? '' : 's'}</h3>
                    {showLink()}
                </div>

            </section>
        </section>);
}

TeacherStatsReferredTeachers.propTypes = {
    isTeacher: PropTypes.bool.isRequired,
    numTeachersReferred: PropTypes.number.isRequired,
};

export default TeacherStatsReferredTeachers;
